var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticStyle: {
        margin: "10% 0",
        "font-family": "DINosaur-a",
        color: "#003333"
      },
      attrs: {
        "before-close": _vm.handleClose,
        visible: _vm.alertDialogVisible,
        center: "",
        title: _vm.dialogBoxTitle,
        width: "100%"
      },
      on: {
        "update:visible": function($event) {
          _vm.alertDialogVisible = $event
        }
      }
    },
    [
      _vm.userTypeErrorCode === 70000
        ? [
            _c("span", { staticClass: "forgotPasswordSpan" }, [
              _vm._v(_vm._s(this.dialogBoxMessage) + ". Please login.")
            ])
          ]
        : _vm.userTypeErrorCode === 60001
        ? [
            _c(
              "span",
              {
                staticClass: "forgotPasswordSpan",
                domProps: { innerHTML: _vm._s(_vm.dialogBoxMessage) }
              },
              [
                _vm._v(
                  _vm._s(this.dialogBoxMessage) +
                    ". Please check your junk mail to ensure you receive\n                    it."
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            {
              attrs: {
                span: 12,
                offset: _vm.userTypeErrorCode === 70000 ? 0 : 12
              }
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "dialog-footer-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleClose }
                },
                [_vm._v("Close")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.userTypeErrorCode === 70000
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "dialog-footer-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.goToUConnect }
                      },
                      [_vm._v("Sign in to U-Connect")]
                    )
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3617e009", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3617e009","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/uConnectCheckUserDialog.vue
// module id = null
// module chunks = 